import script from "./DeleteConfirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteConfirmModal.vue?vue&type=script&setup=true&lang=js"

import "./DeleteConfirmModal.vue?vue&type=style&index=0&id=98d73d56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98d73d56"]])

export default __exports__